var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#888888",
    d: "M23.586,23.586c0.122-0.122,0.262-0.217,0.408-0.299l-2.276-2.277c-0.195-0.195-0.512-0.195-0.707,0 c-0.195,0.196-0.195,0.512,0,0.708l2.271,2.271C23.368,23.846,23.464,23.707,23.586,23.586z",
    className: "color263238 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888888",
    d: "M28.5 31c-.667 0-1.295-.26-1.768-.732l-3.5-3.5C22.76 26.295 22.5 25.668 22.5 25s.26-1.295.732-1.768c.906-.906 2.629-.906 3.535 0l3.5 3.5C30.74 27.205 31 27.832 31 28.5s-.26 1.295-.732 1.768S29.167 31 28.5 31zM25 23.52c-.407 0-.793.152-1.061.42C23.656 24.223 23.5 24.6 23.5 25s.156.777.439 1.061l3.5 3.5c.567.566 1.554.566 2.121 0C29.844 29.277 30 28.9 30 28.5s-.156-.777-.439-1.061l-3.5-3.5C25.793 23.672 25.407 23.52 25 23.52zM13 22.45c-.276 0-.5-.224-.5-.5s.224-.5.5-.5c3.767 0 7.035-2.404 8.133-5.981.081-.264.361-.415.625-.331.264.081.413.36.332.624C20.861 19.763 17.209 22.45 13 22.45z",
    className: "color263238 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#888888",
    d: "M13,25C6.383,25,1,19.617,1,13S6.383,1,13,1s12,5.383,12,12S19.617,25,13,25z M13,2 C6.935,2,2,6.935,2,13s4.935,11,11,11s11-4.935,11-11S19.065,2,13,2z",
    className: "color263238 svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 13,
    r: 0.5,
    fill: "#888888",
    className: "color263238 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAdd);
export default __webpack_public_path__ + "static/media/search-add.29b6c1b22cc9e8322c636024eafa9c6e.svg";
export { ForwardRef as ReactComponent };